module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    staticClass: "gencode"
  }, [_c('div', {
    staticClass: "gencode-select"
  }, [_c('domain-select', {
    attrs: {
      "tip": "该功能仅用于基础流量代码自动安装"
    },
    on: {
      "change": _vm.onDomainChange
    }
  }), _c('div', {
    staticClass: "install-status"
  }, [_vm._v("网站 " + _vm._s(_vm._f("truncate")(_vm.domain.domain)) + " 自动安装代码"), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageStatus == 'installEnd'),
      expression: "pageStatus == 'installEnd'"
    }],
    staticClass: "install-status-success"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("安装成功"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRollback),
      expression: "showRollback"
    }]
  }, [_vm._v(", 您可以在 " + _vm._s(_vm.end_time) + " 之前恢复网站。")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageStatus == 'installEnd'),
      expression: "pageStatus == 'installEnd'"
    }],
    staticClass: "action-recover"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRollback),
      expression: "showRollback"
    }],
    staticClass: "btn btn-primary btn-big",
    on: {
      "click": _vm.rollback
    }
  }, [_vm._v("恢复原网站")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageStatus == 'errorEnd'),
      expression: "pageStatus == 'errorEnd'"
    }],
    staticClass: "install-status-failed"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v("安装失败，请重新安装")])])], 1), _c('div', [_c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v("①")]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("连接FTP服务器")]), _c('v-tooltip', {
    staticClass: "gencode-tooltip",
    attrs: {
      "tip": "您可以向网站管理员、托管公司询问FTP用户名和密码；输入FTP相关信息即可进行代码自动安装，我们不会记录您FTP用户名和密码，请放心使用。",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _c('div', {
    staticClass: "form"
  }, [_c('v-form-item', {
    attrs: {
      "label": "FTP地址："
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftpInfo.ftpaddr),
      expression: "ftpInfo.ftpaddr"
    }],
    staticClass: "size-big",
    domProps: {
      "value": _vm._s(_vm.ftpInfo.ftpaddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftpInfo.ftpaddr = $event.target.value
      }
    }
  }), (!_vm.ftpInfoState.ftpaddr) ? _c('em', {
    staticClass: "error"
  }, [_vm._v("请填写FTP地址")]) : _vm._e()]), _c('v-form-item', {
    attrs: {
      "label": "用户名："
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftpInfo.ftpuser),
      expression: "ftpInfo.ftpuser"
    }],
    domProps: {
      "value": _vm._s(_vm.ftpInfo.ftpuser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftpInfo.ftpuser = $event.target.value
      }
    }
  }), (!_vm.ftpInfoState.ftpuser) ? _c('em', {
    staticClass: "error"
  }, [_vm._v("请填写用户名")]) : _vm._e()]), _c('v-form-item', {
    attrs: {
      "label": "密码："
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftpInfo.ftppwd),
      expression: "ftpInfo.ftppwd"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": _vm._s(_vm.ftpInfo.ftppwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftpInfo.ftppwd = $event.target.value
      }
    }
  }), (!_vm.ftpInfoState.ftppwd) ? _c('em', {
    staticClass: "error"
  }, [_vm._v("请填写密码")]) : _vm._e()]), _c('label', {
    staticClass: "spread-opts",
    on: {
      "click": _vm.toggleFTPOption
    }
  }, [_vm._v("高级选项"), _c('i', {
    staticClass: "fa",
    class: [_vm.useOption ? 'fa-angle-down' : 'fa-angle-right']
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.useOption),
      expression: "useOption"
    }],
    staticClass: "item spread-items"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("初始目录：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftpOption.ftpdirs),
      expression: "ftpOption.ftpdirs"
    }],
    domProps: {
      "value": _vm._s(_vm.ftpOption.ftpdirs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftpOption.ftpdirs = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v(" 端口号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftpOption.ftpport),
      expression: "ftpOption.ftpport"
    }],
    staticClass: "size-small",
    domProps: {
      "value": _vm._s(_vm.ftpOption.ftpport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftpOption.ftpport = $event.target.value
      }
    }
  }), _c('v-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftpOption.is_ssl),
      expression: "ftpOption.is_ssl"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "title": " 开启SSL"
    },
    domProps: {
      "value": (_vm.ftpOption.is_ssl)
    },
    on: {
      "input": function($event) {
        _vm.ftpOption.is_ssl = $event
      }
    }
  })], 1), (!_vm.treeRootData) ? _c('v-form-item', [_c('button', {
    staticClass: "btn btn-primary btn-small",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.connectFTP
    }
  }, [_vm._v("连接")]), (_vm.ftpError) ? _c('em', {
    staticClass: "error"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v(_vm._s(_vm.ftpError))]) : _vm._e()]) : _vm._e(), (_vm.treeRootData) ? _c('p', {
    staticStyle: {
      "color": "#56bf8b",
      "line-height": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("成功链接服务器")]) : _vm._e()], 1), _c('div', {
    staticClass: "gencode-index"
  }, [_c('span', {
    staticClass: "gen-index"
  }, [_vm._v("②")]), _c('span', {
    staticClass: "gen-text"
  }, [_vm._v("设置安装目录")]), _c('v-tooltip', {
    staticClass: "gencode-tooltip",
    attrs: {
      "tip": "请在下方选择监测代码的安装目录，我们会为您选择的目录下的文件添加监测代码。",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })]), _c('p', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("安装路径：")]), (_vm.treeRootData) ? _c('v-folder', {
    attrs: {
      "conf": _vm.treeDataConf,
      "data": _vm.treeRootData,
      "ajax": _vm.treeAjaxConf
    },
    on: {
      "change": _vm.onFolderChange
    }
  }) : _vm._e(), _c('div', {
    staticClass: "btn btn-primary btn-medium",
    class: {
      disabled: !_vm.treeRootData,
      'start-install': _vm.treeRootData
    },
    on: {
      "click": _vm.startInstall
    }
  }, [_vm._v("开始安装")])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaskPanel),
      expression: "showMaskPanel"
    }],
    staticClass: "modal-groups"
  }, _vm._l((_vm.modalConfig), function(modal) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (modal.status === _vm.pageStatus),
        expression: "modal.status === pageStatus"
      }],
      staticClass: "modal-item"
    }, [_c('div', {
      staticClass: "modal-item--content"
    }, [_c('div', {
      staticClass: "content-header"
    }, [_vm._v(_vm._s(modal.title))]), _c('hr'), _c('div', {
      staticClass: "content-desc"
    }, [_vm._v(" " + _vm._s(modal.content))]), (modal.btns && modal.btns.length) ? _c('div', {
      staticClass: "btn-wrap"
    }, _vm._l((modal.btns), function(btn) {
      return _c('button', {
        staticClass: "btn btn-big",
        class: 'btn-' + (btn.type || 'primary'),
        on: {
          "click": btn.click
        }
      }, [_vm._v(_vm._s(btn.text))])
    })) : _vm._e()])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c6dfeaa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c6dfeaa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/gencode_install.vue
// module id = 708
// module chunks = 0